/* RAVii model info on product pages: the MODEL INFO button on the photos and its panel.
   The data and the styles live in this file, so the product page itself stays small and the
   browser keeps one cached copy for every product.
   To add or change a product, edit MODEL_INFO:
     'product-handle': { size: 'XS', colours: ['Colour as written in the store'] }
   Add m: 'b', 'c', 'd', 'e' or 'f' to pick the model (see MODELS: a Moonique, b Fifi, c Ploy,
   d Viva, e Nan, f Sunshine). Without m, model a is used.
   A product whose colours use different models or sizes takes a list of entries.
   size: '' shows the measurements only. Colour names must match the product's Color option
   values (capitals are ignored). Updated 27 October 2026 from the photoshoot tracking sheet.
   Computer: the button floats in the bottom left corner of the visible photos and the panel opens
   only when the button is pressed. It follows the photos while they are on screen and is hidden
   (and the panel closed) as soon as the photos have scrolled out of view. The page scrolls inside
   its own container, so scrolling is listened for everywhere, not only on the window.
   Phone: the button sits on the product image itself and scrolls with it. It is hidden while the
   menu, search or cart is open, and also once the photos are out of view. */
(function () {
  var wrap = document.querySelector('.ravii-model');
  if (!wrap || window.__raviiModelInfo) return;
  window.__raviiModelInfo = true;

  var style = document.createElement('style');
  style.textContent = `
.ravii-model{position:fixed;left:32px;bottom:32px;z-index:30;display:flex;flex-direction:column;align-items:flex-start;gap:12px;width:min(340px,calc(100vw - 32px));font-family:var(--font-body--family);color:#000;pointer-events:none;-webkit-tap-highlight-color:transparent}
.ravii-model[hidden]{display:none}
.ravii-model__panel{box-sizing:border-box;width:100%;padding:14px 18px;background:rgba(255,255,255,0.92);font-size:0.8125rem;line-height:1.5;opacity:0;transform:translateY(6px);transition:opacity 0.25s ease,transform 0.25s ease;pointer-events:none}
.ravii-model[data-open='true'] .ravii-model__panel{opacity:1;transform:none;pointer-events:auto}
.ravii-model__line{margin:0}
.ravii-model__line[hidden]{display:none}
.ravii-model__line + .ravii-model__line{margin-top:6px}
.ravii-model__line[hidden] + .ravii-model__line{margin-top:0}
.ravii-model__btn{pointer-events:auto;min-height:40px;padding:11px 20px;border:0;border-radius:0;background:#fff;color:#000;font-family:inherit;font-size:0.75rem;letter-spacing:0.16em;text-transform:uppercase;line-height:1.2;cursor:pointer;touch-action:manipulation}
.ravii-model[data-mobile='true']{position:absolute;left:12px;bottom:12px;top:auto;width:auto;max-width:calc(100% - 24px);gap:8px;z-index:6}
.ravii-model[data-mobile='true'] .ravii-model__panel{width:max-content;max-width:100%;padding:12px 14px;font-size:0.75rem;display:none}
.ravii-model[data-mobile='true'][data-open='true'] .ravii-model__panel{display:block}
.ravii-model[data-mobile='true'] .ravii-model__btn{min-height:44px;padding:13px 18px;font-size:0.6875rem}
body:has(.menu-drawer-container[open]) .ravii-model,body:has(.menu-drawer-container.menu-open) .ravii-model,body:has(dialog[open]) .ravii-model{display:none !important}
@media (prefers-reduced-motion:reduce){.ravii-model__panel{transition:none}}
`;
  document.head.appendChild(style);

  var Q = String.fromCharCode(34);
  var LEAD = 'Model wears a size ';
  var MODEL = {
    line1: LEAD,
    line2: `Height: 175cm/5'9` + Q + `, Bust: 84cm/33in, Waist: 64cm/25in, Hips: 99cm/39in`
  };
  var MODEL_B = {
    line1: LEAD,
    line2: `Height: 175cm/5'9` + Q + `, Bust: 76cm/30in, Waist: 64cm/25in, Hips: 91cm/36in`
  };
  var MODEL_C = {
    line1: LEAD,
    line2: `Height: 161cm/5'3.5` + Q + `, Bust: 84cm/33in, Waist: 66cm/26in, Hips: 94cm/37in`
  };
  var MODEL_D = {
    line1: LEAD,
    line2: `Height: 174cm/5'8.5` + Q + `, Bust: 84cm/33in, Waist: 64cm/25in, Hips: 91cm/36in`
  };
  var MODEL_E = {
    line1: LEAD,
    line2: 'Waist: 26in, Hips: 35in'
  };
  var MODEL_F = {
    line1: LEAD,
    line2: `Height: 174cm/5'8.5` + Q + `, Bust: 84cm/33in, Waist: 64cm/25in, Hips: 88cm/35in`
  };
  var MODELS = { a: MODEL, b: MODEL_B, c: MODEL_C, d: MODEL_D, e: MODEL_E, f: MODEL_F };

  var MODEL_INFO = {
    'amelie-dress': [
      { size: 'XS', colours: ['White with Black', 'White', 'Black', 'Navy', 'Burgundy'] },
      { size: 'XS', colours: ['Cream', 'Pink'], m: 'd' }
    ],
    'amelie-skirt': [
      { size: 'XS', colours: ['Black', 'Cream', 'Pink'], m: 'd' },
      { size: 'S', colours: ['Burgundy', 'Navy'] }
    ],
    'amelie-top': [
      { size: 'XS', colours: ['White with Black', 'Cream', 'Pink'], m: 'd' },
      { size: 'XS', colours: ['Black', 'Navy', 'Burgundy'] }
    ],
    'asymmetric-skirt': [
      { size: 'XS', colours: ['Blue', 'Cream', 'Pale Pink'], m: 'c' },
      { size: 'S', colours: ['Yellow', 'Orange'] },
      { size: 'XS', colours: ['Pink', 'Purple'], m: 'd' }
    ],
    'asymmetric-top': [
      { size: 'XS', colours: ['Blue', 'Cream', 'Pale Pink', 'White (Wool Blend)', 'Black (Wool Blend)'], m: 'c' },
      { size: 'XS', colours: ['Yellow', 'Orange', 'Brown', 'Grey (Wool Blend)'] },
      { size: 'XS', colours: ['Pink', 'Purple'], m: 'd' }
    ],
    'blair-balloon-skirt': { size: 'M', colours: ['Cream', 'Black'], m: 'c' },
    'blair-maxi-dress': { size: 'S', colours: ['Cream (Tweed)', 'Black (Tweed)'], m: 'c' },
    'blair-mini-skirt': { size: 'XS', colours: ['Cream (Tweed)', 'Black (Tweed)'], m: 'b' },
    'blair-top': [
      { size: 'XS', colours: ['Cream'], m: 'b' },
      { size: 'S', colours: ['Black'], m: 'c' }
    ],
    'celeste-skirt': { size: 'S', colours: ['Blue', 'Orange'], m: 'd' },
    'cotton-shirt': [
      { size: 'S', colours: ['White', 'Off-White', 'Caramel', 'Ash Brown', 'Dark Brown', 'Burgundy'] },
      { size: 'S', colours: ['Beige', 'Light Green', 'Light Blue', 'Navy', 'Pink'], m: 'b' }
    ],
    'delphine-corset-top': { size: 'XS', colours: ['Pink', 'Cream', 'Blue', 'Navy', 'Black'] },
    'delphine-maxi-skirt': { size: 'XS', colours: ['Pink', 'Cream', 'Blue', 'Navy', 'Black'] },
    'delphine-mini-skirt': [
      { size: 'XS', colours: ['Pink', 'Cream'], m: 'd' },
      { size: 'XS', colours: ['Blue', 'Navy', 'Black'], m: 'b' }
    ],
    'elodie-mini-dress': [
      { size: 'XS', colours: ['White', 'Black', 'Red', 'Navy'] },
      { size: 'XS', colours: ['Cream', 'Purple'], m: 'd' }
    ],
    'fish-tail-skirt': [
      { size: 'S', colours: ['White', 'Black'], m: 'b' },
      { size: 'S', colours: ['Cream (Satin)', 'Black (Satin)'] }
    ],
    'halter-square-top': [
      { size: 'XS', colours: ['White', 'Black', 'Pink', 'Red', 'Navy', 'Polka Dot - Black'] },
      { size: 'XS', colours: ['Cream'], m: 'd' },
      { size: 'XS', colours: ['Purple'], m: 'b' }
    ],
    'juliette-shirt': { size: 'XS', colours: ['Cream', 'Black', 'Brown'], m: 'b' },
    'lady-boat-neck-top': { size: 'XS', colours: ['White (Cotton)'], m: 'b' },
    'lady-maxi-skirt': { size: 'XS', colours: ['White (Cotton)', 'Black (Cotton)'], m: 'b' },
    'moonpearl-blouse': [
      { size: 'XS', colours: ['White'] },
      { size: 'XS', colours: ['Black'], m: 'b' }
    ],
    'moonpearl-skirt': { size: 'XS', colours: ['White', 'Black'], m: 'b' },
    'noelle-bow-top': [
      { size: 'XS', colours: ['Polka Dot - White', 'White', 'Black'] },
      { size: 'XS', colours: ['Polka Dot - Black'], m: 'b' }
    ],
    'noelle-skirt': { size: 'XS', colours: ['White', 'Black'] },
    'pleated-maxi-skirt': { size: 'S', colours: ['White', 'Black'], m: 'c' },
    'pre-order-blair-mini-dress': { size: 'XS', colours: ['Cream (Tweed)', 'Black (Tweed)'], m: 'b' },
    'pre-order-camille-maxi-dress': [
      { size: 'XS', colours: ['Polka Dot - White', 'White'] },
      { size: 'XS', colours: ['Polka Dot - Cream'], m: 'd' }
    ],
    'pre-order-camille-maxi-dress-copy': [
      { size: 'S', colours: ['Polka Dot - White', 'Polka Dot - Black', 'Black', 'Navy'] },
      { size: 'XS', colours: ['White'], m: 'c' },
      { size: 'XS', colours: ['Cream', 'Purple', 'Blue'], m: 'd' }
    ],
    'pre-order-celeste-set-top-skirt': { size: 'XS', colours: ['Blue', 'Orange'], m: 'd' },
    'pre-order-claudia-mini-dress': [
      { size: 'XS', colours: ['Polka Dot - White', 'Polka Dot - Black', 'White', 'Black', 'Navy', 'Red'] },
      { size: 'XS', colours: ['Cream', 'Purple', 'Blue'], m: 'd' }
    ],
    'pre-order-high-waisted-shorts': [
      { size: 'XS', colours: ['Off-White'], m: 'f' },
      { size: 'XS', colours: ['Black', 'Grey'], m: 'e' },
      { size: 'XS', colours: ['Navy', 'Khaki', 'Brown'], m: 'b' },
      { size: 'XS', colours: ['Cream'], m: 'd' }
    ],
    'pre-order-high-waisted-shorts-1': { size: 'XS', colours: ['Off-White', 'Black'], m: 'b' },
    'pre-order-midi-pencil-skirt-1': [
      { size: 'S', colours: ['Off-White'], m: 'c' },
      { size: 'XS', colours: ['Black'], m: 'f' },
      { size: 'XS', colours: ['Grey', 'Navy', 'Cream', 'Khaki', 'Brown'], m: 'b' }
    ],
    'pre-order-midnight-collection-shorts-trousers-copy': { size: 'XS', colours: ['Off-White', 'Black'], m: 'b' },
    'pre-order-midnight-shorts-copy': { size: 'XS', colours: ['Off-White', 'Black', 'Grey', 'Navy', 'Khaki', 'Brown'], m: 'b' },
    'pre-order-pleated-pants': { size: 'S', colours: ['White', 'Black'], m: 'c' },
    'pre-order-pocket-mini-skirt': [
      { size: 'XS', colours: ['Off-White'], m: 'e' },
      { size: 'XS', colours: ['Black'], m: 'b' }
    ],
    'pre-order-ravii-classic-vest': { size: 'XS', colours: ['White', 'Black', 'Grey'], m: 'b' },
    'pre-order-ravii-sicily-cotton-linen-maxi-dress': [
      { size: 'S', colours: ['White', 'Black', 'Cream', 'Olive', 'Navy', 'Red', 'Burgundy'] },
      { size: 'XS', colours: ['Blue'], m: 'd' }
    ],
    'pre-order-ravii-sophie-maxi-dress': { size: 'XS', colours: ['White', 'Black', 'Navy', 'Cream', 'Pink', 'Red'], m: 'c' },
    'pre-order-ravii-sophie-mini-dress': [
      { size: 'XS', colours: ['Cream', 'Pink'], m: 'd' },
      { size: 'XS', colours: ['Navy', 'Black'] }
    ],
    'pre-order-ravii-vivienne-maxi-dress': [
      { size: 'XS', colours: ['White', 'Black', 'Yellow', 'Navy', 'Red'] },
      { size: 'XS', colours: ['Cream', 'Blue', 'Purple', 'Pink'], m: 'd' }
    ],
    'pre-order-ravii-wildflower-maxi-dress': [
      { size: 'XS', colours: ['Blue'], m: 'd' },
      { size: 'XS', colours: ['Yellow'] }
    ],
    'pre-order-rosalie-midi-dress': [
      { size: 'XS', colours: ['White Floral'] },
      { size: 'XS', colours: ['Cream Floral', 'White'], m: 'd' }
    ],
    'pre-order-satin-bat-sleeve-top': { size: 'S', colours: ['Cream', 'Black'], m: 'b' },
    'pre-order-satin-cowl-neck-top': { size: 'XS', colours: ['Cream', 'Black'] },
    'pre-order-satin-drape-waist-top': { size: 'XS', colours: ['Cream', 'Black'], m: 'b' },
    'pre-order-satin-lounge-pants': { size: 'S', colours: ['Cream', 'Black'], m: 'b' },
    'pre-order-satin-round-neck-top': { size: 'XS', colours: ['Cream', 'Black'], m: 'b' },
    'pre-order-sylvie-dress': [
      { size: 'S', colours: ['White'] },
      { size: 'XS', colours: ['Black', 'Light Pink'], m: 'b' }
    ],
    'pre-order-sylvie-dress-copy': { size: 'S', colours: ['White', 'Black', 'Light Pink'], m: 'b' },
    'ravii-elodie-maxi-dress': [
      { size: 'S', colours: ['White', 'Black', 'Yellow', 'Navy'] },
      { size: 'XS', colours: ['Blue', 'Purple', 'Pink'], m: 'd' },
      { size: 'XS', colours: ['Red'] }
    ],
    'rosette-maxi-skirt': [
      { size: 'XS', colours: ['White Floral', 'Cream Floral'], m: 'd' },
      { size: 'S', colours: ['White'] }
    ],
    'rosette-midi-skirt': [
      { size: 'XS', colours: ['White Floral', 'Cream Floral'], m: 'd' },
      { size: 'S', colours: ['White'] }
    ],
    'rosette-top': [
      { size: 'S', colours: ['White Floral', 'Cream Floral'], m: 'd' },
      { size: 'S', colours: ['White'] }
    ],
    'sicily-mini-dress': { size: 'XS', colours: ['Cream', 'Blue', 'Olive'] },
    'solene-maxi-dress': [
      { size: 'XS', colours: ['Cream'], m: 'd' },
      { size: 'XS', colours: ['Blue', 'Pink', 'White'] }
    ],
    'solene-top-skirt': [
      { size: 'XS', colours: ['Cream', 'Blue', 'Pink'], m: 'd' },
      { size: 'S', colours: ['White'] }
    ],
    'sophie-lounge-pants': { size: 'S', colours: ['White', 'Black', 'Navy', 'Cream', 'Pink', 'Burgundy'] },
    'sophie-top': { size: 'S', colours: ['White', 'Black', 'Navy', 'Cream', 'Pink', 'Burgundy'] },
    'summer-haze-maxi-dress': [
      { size: 'XS', colours: ['White', 'Cream', 'Pink', 'Red'], m: 'd' },
      { size: 'S', colours: ['Black', 'Navy'] }
    ],
    'vivienne-mini-dress-1': [
      { size: 'XS', colours: ['White', 'Black'] },
      { size: 'XS', colours: ['Cream'], m: 'd' }
    ],
    'wildflower-maxi-skirt': [
      { size: 'XS', colours: ['Blue'], m: 'd' },
      { size: 'XS', colours: ['Yellow'] }
    ],
    'wildflower-top': [
      { size: 'XS', colours: ['Blue'], m: 'd' },
      { size: 'XS', colours: ['Yellow'] }
    ]
  };

  var btn = wrap.querySelector('.ravii-model__btn');
  var panel = wrap.querySelector('.ravii-model__panel');
  var l1 = wrap.querySelector('[data-ravii-model-1]');
  var l2 = wrap.querySelector('[data-ravii-model-2]');
  var handleNow = wrap.getAttribute('data-handle') || '';
  var phone = window.matchMedia('(max-width: 749px)');
  var ticking = false;
  var lastColour = null;

  // the button needs at least this much of the photos on screen (in pixels) to be shown
  var MIN_PHOTO_VISIBLE = 220;

  function isOpen() {
    return wrap.getAttribute('data-open') === 'true';
  }

  function setOpen(open) {
    if (open) {
      wrap.setAttribute('data-open', 'true');
    } else {
      wrap.removeAttribute('data-open');
    }
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function infoFor(colour) {
    var raw = MODEL_INFO[handleNow];
    if (!raw || !colour) return null;
    var entries = Array.isArray(raw) ? raw : [raw];
    var wanted = String(colour).trim().toLowerCase();
    for (var k = 0; k < entries.length; k++) {
      var ok = entries[k].colours.some(function (c) { return c.toLowerCase() === wanted; });
      if (ok) return entries[k];
    }
    return null;
  }

  function currentColour() {
    var picker = document.querySelector('variant-picker[data-template-product-match=true]') || document.querySelector('variant-picker');
    if (!picker) return null;
    var inputs = picker.querySelectorAll('fieldset input:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (/colou?rs?$/i.test(inputs[i].dataset.optionName || '')) return inputs[i].value;
    }
    var sels = picker.querySelectorAll('select');
    for (var j = 0; j < sels.length; j++) {
      var o = sels[j].options[sels[j].selectedIndex];
      if (o && /colou?rs?$/i.test(o.dataset.optionName || '')) return sels[j].value;
    }
    return null;
  }

  // phone: put the button inside the product image area; computer: back on the page
  function mount() {
    if (phone.matches) {
      var host = document.querySelector('media-gallery slideshow-container') || document.querySelector('media-gallery');
      if (!host) return false;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (wrap.parentNode !== host) host.appendChild(wrap);
      if (wrap.getAttribute('data-mobile') !== 'true') {
        wrap.setAttribute('data-mobile', 'true');
        wrap.removeAttribute('style');
      }
      return true;
    }
    if (wrap.getAttribute('data-mobile') === 'true') {
      wrap.removeAttribute('data-mobile');
      wrap.removeAttribute('style');
    }
    if (wrap.parentNode !== document.body) document.body.appendChild(wrap);
    return false;
  }

  function apply(colour) {
    setOpen(false);
    var info = infoFor(colour);
    if (!info) {
      wrap.hidden = true;
      return;
    }
    var m = MODELS[info.m || 'a'];
    if (info.size) {
      l1.hidden = false;
      l1.textContent = m.line1 + info.size;
    } else {
      l1.hidden = true;
      l1.textContent = '';
    }
    l2.textContent = m.line2;
    wrap.hidden = false;
    place();
  }

  // the colour is looked up again once the page has been built, in case the picker came later
  function sync() {
    var colour = currentColour();
    if (!colour || colour === lastColour) return;
    lastColour = colour;
    apply(colour);
  }

  // keep the button on the photos only. Computer: in the bottom left corner of the visible part
  // of the photos. Both: hidden, with the panel closed, once the photos have scrolled out of view.
  function place() {
    var onPhone = mount();
    var g = document.querySelector('media-gallery');
    if (!g || wrap.hidden) return;
    var r = g.getBoundingClientRect();
    var vh = window.innerHeight;
    var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    if (visible < MIN_PHOTO_VISIBLE) {
      if (isOpen()) setOpen(false);
      wrap.style.visibility = 'hidden';
      return;
    }
    wrap.style.visibility = 'visible';
    if (onPhone) return;
    var inset = 32;
    wrap.style.left = Math.max(r.left, 0) + inset + 'px';
    wrap.style.bottom = Math.max(vh - Math.min(r.bottom, vh), 0) + inset + 'px';
    wrap.style.width = Math.min(340, Math.max(r.width - inset * 2, 160)) + 'px';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; place(); });
  }

  function toggle(event) {
    // keep the press from reaching the photo underneath (which would zoom it or swipe it)
    event.stopPropagation();
    if (event.cancelable) event.preventDefault();
    setOpen(!isOpen());
  }

  ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'mousedown'].forEach(function (type) {
    wrap.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
  });
  btn.addEventListener('click', toggle);
  panel.addEventListener('click', function (e) { e.stopPropagation(); setOpen(false); });

  // the page scrolls inside its own container, and scroll events do not bubble up to the window,
  // so listen in the capture phase to hear every scroll on the page
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', function () { place(); });
  if (phone.addEventListener) phone.addEventListener('change', function () { place(); });

  // the photo area can be rebuilt by the theme (for example when a colour is picked), so
  // put the button back whenever it has been dropped
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued || wrap.hidden || !phone.matches) return;
      var host = document.querySelector('media-gallery slideshow-container') || document.querySelector('media-gallery');
      if (host && wrap.parentNode === host) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; place(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (!target.closest('variant-picker')) return;
    if (target.closest('product-card') || target.closest('quick-add-dialog')) return;
    var optionName = target.dataset.optionName;
    if (target instanceof HTMLSelectElement) {
      var chosen = target.options[target.selectedIndex];
      optionName = chosen && chosen.dataset.optionName;
    }
    if (!optionName || !/colou?rs?$/i.test(optionName)) return;
    lastColour = target.value;
    apply(target.value);
    window.setTimeout(place, 400);
    window.setTimeout(place, 1200);
  });

  sync();
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', function () { sync(); place(); });
  window.setTimeout(sync, 300);
  window.setTimeout(sync, 1000);
})();
